































import { Component, Prop, Vue } from 'vue-property-decorator';
import DocumentTableViewer from '@/components/base/DocumentTableViewer.vue';
import { deleteUserDocument, getUserDocuments } from '@/api/profile';
import UploadingForm from '@/components/profile/personal-details/documents/UploadingForm.vue';
import cloneDeep from 'clone-deep';
import SignatureComponent from '@/components/base/SignatureComponent.vue';

@Component({
  data: () => ({}),
  components: { SignatureComponent, UploadingForm, DocumentTableViewer },
})
export default class PersonalDocument extends Vue {
  @Prop({ default: false }) single: boolean;
  @Prop({ default: false }) fullViewMode: boolean;

  private loading = false;
  private dialog = false;
  private documents = [];
  private docForEdit = {};

  $refs!: {
    vue: Vue;
    uploadingForm: any;
  };

  async created() {
    await this.getData();
  }

  async getData() {
    this.loading = true;
    this.documents = await getUserDocuments();
    this.loading = false;
  }

  editDocument(document: object) {
    this.docForEdit = cloneDeep(document);
    this.dialog = true;
  }

  async deleteDocument(document: any) {
    this.loading = true;
    await deleteUserDocument(document.id);
    await this.getData();
    this.loading = false;
  }

  async closeModalForm() {
    this.docForEdit = {};
    this.dialog = false;
  }
}
